import React from 'react';
import {FormikProps} from 'formik';
import {useIntl} from 'react-intl';
import {Form} from 'react-bootstrap';
import clsx from 'clsx';

interface Props<T> {
  name: keyof T & string;
  label: string;
  formik: FormikProps<T>;
  required?: boolean;
}

function TextInputFormik<T extends Record<string, any>>({label, name, formik, required = true}: Props<T>) {
  const intl = useIntl();

  const touched = formik.touched[name];
  const errors = formik.errors[name];

  const getErrorMessage = () => {
    if (!errors) return '';
    if (typeof errors === 'string') return errors;
    if (Array.isArray(errors)) return errors.join(', ');
    return '';
  };

  return (
    <Form.Group controlId={name}>
      <Form.Label className="fs-5 required" style={{fontWeight: 600}}>
        {intl.formatMessage({id: label})}
      </Form.Label>
      <Form.Control
        name={name}
        value={formik.values[name]}
        className={clsx(
          'form-control-sm',
          {'is-invalid': touched && errors},
          {
            'is-valid': touched && !errors,
          }
        )}
        type="text"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        onReset={formik.handleReset}
        aria-required={required}
        aria-invalid={!!(touched && errors)}
        aria-describedby={touched && errors ? `${name}-error` : undefined}
      />
      {touched && errors && (
        <div id={`${name}-error`} className="fv-plugins-message-container">
          <div className="fv-help-block">
            <span role="alert">{getErrorMessage()}</span>
          </div>
        </div>
      )}
    </Form.Group>
  );
}

export default TextInputFormik;
